import type * as React from 'react';

import type { UserContextValue } from './types';
import { UserContext as CustomUserContext, UserProvider as CustomUserProvider } from './user-provider';

let UserProvider: React.FC<{ children: React.ReactNode }>;

let UserContext: React.Context<UserContextValue | undefined>;

UserContext = CustomUserContext;
UserProvider = CustomUserProvider;

export { UserProvider, UserContext };
